function formatFormValues(obj = {}) {
  return Object.keys(obj).reduce((prev, current) => {
    const entry = obj[current];
    if (Object.prototype.hasOwnProperty.call(entry, 'feature_id')) {
      if (Object.prototype.hasOwnProperty.call(entry, 'value_unit') && entry.value_unit !== null) {
        prev[entry.feature_id] = {
          value: entry.value,
          value_unit: entry.value_unit,
          maxValue: entry.maxValue ? entry.maxValue : null
        };
      } else if (Object.prototype.hasOwnProperty.call(entry, 'value_unit') && entry.checkBox === true) {
        prev[entry.feature_id] = entry.checkBox;
      } else {
        prev[entry.feature_id] = entry.value;
      }
    } else if (Array.isArray(entry) && entry.length === 1) {
      prev[current] = { ...entry[0] };
    } else {
      prev[current] = entry;
    }
    return prev;
  }, {});
}

function getStep1Module4State(state) {
  return {
    operationType: state.step1Module4.moduleInfo.operationType,
    realEstateTypeId: state.step1Module4.realEstateTypeId,
    unitMeasurement: state.step1Module4.unitMeasurement,
    formValues: { ...formatFormValues(state.step1Module4.formValues) }
  };
}

export { getStep1Module4State };
